import App from 'app/app.js';

// This is Common Service we can use it for data sharing, custom validations.
function CommonService(JobStore, ContentStore, $window, LogoutSuccessAction, SessionTimeoutAction) {
  this.openStudentModelForSmartUrl = false;
  this.clickSubmitForSmartUrl = false;
  this.abandonedCartNotificationShown = false;

  this.gradeOrTeacherNameRequired = function (event) {
    return this.gradeRequired(event) || this.teacherNameRequired(event);
  };

  this.gradeRequired = function (event) {
    if (!event) {
      return false;
    }
    var isUnderclass = JobStore.isUnderclass(event.pictureDayId);
    var isClassRoomGroupOrPayOnly =
      JobStore.isClassRoomGroup(event.pictureDayId) || JobStore.isPayOnly(event.pictureDayId);
    var isPreOrderWithGNA =
      JobStore.isPreOrder(event.pictureDayId) && (!event.subjectGrade || event.subjectGrade === 'GNA');

    return isUnderclass && (isClassRoomGroupOrPayOnly || isPreOrderWithGNA);
  };

  this.teacherNameRequired = function (event) {
    if (!event) {
      return false;
    }
    var isUnderclass = JobStore.isUnderclass(event.pictureDayId);
    var isClassRoomGroupOrPayOnly =
      JobStore.isClassRoomGroup(event.pictureDayId) || JobStore.isPayOnly(event.pictureDayId);

    return isUnderclass && isClassRoomGroupOrPayOnly;
  };

  this.setGradeAndTeacherName = function (formData, subject) {
    if (formData.subjectTeacherName) {
      subject.subjectTeacherName = formData.subjectTeacherName;
    }
    if (formData.subjectGrade) {
      subject.subjectGrade = formData.subjectGrade;
    }
    subject.dontKnowTeacherName = formData.dontKnowTeacherName;
  };

  // Send Picture Day Info to SFLY Mobile app
  this.sendPictureDayToApp = function (eventData) {
    if (!eventData) {
      return;
    }

    var params = {
      id: eventData.pictureDayId,
      firstName: eventData.subjectFirstName,
      lastName: eventData.subjectLastName,
      grade: eventData.subjectGrade
    };

    // Trying to call for iOS native method.
    if (!!$window.webkit) {
      if (!!$window.webkit.messageHandlers.savePictureDayId) {
        $window.webkit.messageHandlers.savePictureDayId.postMessage(JSON.stringify(params));
      }
    }

    // Trying to call for Android native method.
    if (!!$window.appInterface) {
      $window.appInterface.savePictureDayId(JSON.stringify(params));
    }
  };

  this.getLogoAlt = function () {
    return ContentStore.getContent('MOBILE_TRANS_HOME', ContentStore.appendCountryCode('BRAND_ALT_TXT'));
  };

  this._clearAll = () => {
    this.abandonedCartNotificationShown = false;
  };

  SessionTimeoutAction.register(this._clearAll);
  LogoutSuccessAction.register(this._clearAll);
}

App.service('CommonService', [
  'JobStore',
  'ContentStore',
  '$window',
  'LogoutSuccessAction',
  'SessionTimeoutAction',
  CommonService
]);
